// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"c113131b","47":"387e4861","50":"786a9ba2","329":"0ebf8054","402":"f2c374c6","432":"ec61b4c1","435":"a60b9bf9","452":"f353bdd4","635":"65af5725","681":"b9cefdcf","893":"60b6e6da","918":"e174aedc","924":"e0e246e9","965":"598c5fd8","995":"41278341"}[chunkId] + ".chunk.js";
};